export enum AuthorityUser {
  CONFIGURATION_USER_ACCOUNT_AMAZON = '6.5',

  CONFIGURATION_USER_MATRIX_UPDATE = '6.4.1',
  CONFIGURATION_USER_MATRIX_CRM_SETTINGS_READ = '6.4.1',
  CONFIGURATION_USER_MATRIX_CRM_SETTINGS_CREATE = '6.4.1',
  CONFIGURATION_USER_MATRIX_CRM_SETTINGS_UPDATE = '6.4.1',

  CONFIGURATION_USER_INVOICE_SETTINGS_READ = '6.4.1',
  CONFIGURATION_USER_INVOICE_SETTINGS_CREATE = '6.4.1',
  CONFIGURATION_USER_INVOICE_SETTINGS_UPDATE = '6.4.1',

  CONFIGURATION_USER_EDIT_SYSTEM_SETTINGS = '6.4.1',
  CONFIGURATION_USER_SYSTEM_SETTINGS = '6.4',
  CONFIGURATION_USER_EDIT_USERS = '6.3.4',
  CONFIGURATION_USER_DELETE_USERS = '6.3.3',
  CONFIGURATION_USER_ADD_USERS = '6.3.2',
  CONFIGURATION_USER_VIEW_USERS = '6.3.1',
  CONFIGURATION_USER_USERS = '6.3',
}
